<app-home-hero></app-home-hero>

<section class="container">
  <div class="row">
    <div class="col-12 col-lg-10 offset-lg-1">
      <img class="img-fluid" src="assets/img/logos.jpg" />
    </div>
  </div>
</section>

<section class="container mt-4">
  <div class="row">
    <div class="col-12">
      <div class="row mb-n4">
        <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mb-4">
          <app-card-testimonial name="Michael Chysky" company="DZ BANK AG" image="/assets/img/testimonial-avatar-michael.jpg">           
            Seit sechs Jahren ist skillconomy unser verlässlicher Partner zur Gewinnung passiver Bewerber. Das innovative und effiziente KI Modell überzeugt uns.
          </app-card-testimonial>
        </div>

        <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mb-4">
          <app-card-testimonial name="Sarah Issiakou" company="DKV Mobility" image="/assets/img/testimonial-avatar-sarah.jpg">
            VONQ für den aktiven und skillconomy für den passiven Markt. Mit dieser Kombination haben wir für uns das perfekte Setup gefunden.
          </app-card-testimonial>
        </div>

        <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mb-4">
          <app-card-testimonial name="Magdalena Kalinowski" company="SMS Group GmbH" image="/assets/img/testimonial-avatar-magdalena.jpg">
            Seit sieben Jahren arbeiten wir mit skillconomy im Active Sourcing. Die neue KI ist nach der beeindruckenden Candidate Experience der nächste Gamechanger.
          </app-card-testimonial>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="container">
  <div class="row justify-content-center">

    <div class="col-12 col-lg-8">
      <h1 class="text-center highlight mb-0">
        Wer den <span class="emphasize">passiven Bewerbermarkt</span> von Anfang an adressiert, besetzt seine Stellen nachweislich schneller und kostengünstiger.
      </h1>
    </div>
  </div>
</section>

<section class="container" anchor="benefits">

  <app-section-intro>
    <span headline>Erreiche 20 Mio. passive Talente,  <br class="d-none d-lg-inline" /> ohne etwas zu tun</span>
    Kein Tool, keine Aufgaben! skillconomy erschließt den passiven Bewerbermarkt automatisch für dich. Qualifizierte Bewerber:innen landen direkt in deinem ATS – du musst nichts tun.
  </app-section-intro>

  <div class="row mt-6">
    <div class="col-12 col-lg-10 offset-lg-1">
      <div class="row mt-n4">
        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0 mt-4">
          <app-card-value-proposition headline="KI-Sourcing-Agent" image="assets/img/visual-screening.jpg">
            Unsere KI bietet einen völlig neuen Ansatz für die Suche nach passenden Kandidat:innen. Sie wurde auf Millionen von Profilen speziell für den deutschen Arbeitsmarkt trainiert. Dabei hat sie typische Karrierepfade und die spezifischen Anforderungen tausender Unternehmen erlernt. Mit diesem Wissen findet sie die besten Kandidat:innen für deine Stelle – innerhalb von Millisekunden.
          </app-card-value-proposition>
        </div>

        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0 mt-4">
          <app-card-value-proposition headline="Intelligente Jobsites" image="assets/img/visual-jobsite.jpg">
            Für jede Stelle generiert unsere KI eine intelligente Jobsite, die alle relevanten Informationen klar und überzeugend aufbereitet – und das vollautomatisch. Die Jobsites sind individuell an das Profil der jeweiligen Kandidat:innen angepasst und ermöglichen eine niedrigschwellige Bewerbung. Sie erfassen gezielt fehlende Angaben und stellen sicher, dass deine Must-Have-Anforderungen wirklich erfüllt sind.
          </app-card-value-proposition>
        </div>

        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0 mt-4">
          <app-card-value-proposition headline="Individualisierte Direktansprache" image="assets/img/visual-outreach.jpg">
            Die Ansprache passiver Kandidat:innen erfolgt über unsere eigene Infrastruktur – ganz ohne dein Zutun und ohne dass du eigene Recruiter-Zugänge benötigst. Die Erstnachricht wird individuell auf die jeweilige Kandidat:in abgestimmt und erzielt dadurch deutlich überdurchschnittliche Besucherraten für die verlinkte Jobsite.
          </app-card-value-proposition>
        </div>

        <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-0 mt-4">
          <app-card-value-proposition headline="100% DSGVO- und EU-Konformität" image="assets/img/visual-compliance.jpg">
            Unsere Plattform erfüllt alle Anforderungen an ein datenschutzkonformes KI-basiertes Active Sourcing. Das Hosting erfolgt ausschließlich in zertifizierten Rechenzentren innerhalb Europas. Alle Prozesse sind DSGVO-konform und unsere KI wurde von Anfang an im Einklang mit den Anforderungen des EU AI Act entwickelt.
          </app-card-value-proposition>
        </div>

      </div>
    </div>
  </div>
</section>

<section class="container" anchor="integration">

  <app-section-intro>
    <span headline>Perfekt integriert in  <br class="d-none d-lg-inline" />deinen Recruiting-Prozess</span>
    skillconomy synchronisiert sich in Echtzeit mit deiner Karriereseite, analysiert innerhalb von Sekunden mehr als 20 Millionen Profile und generiert passgenaue Jobsites für jede Stelle. Du brauchst nur deine Freigabe zu erteilen – und erhältst Bewerbungen direkt in dein ATS.
  </app-section-intro>

  <div class="row mt-6">
    <div class="col-12 col-lg-12">
      <img class="img-fluid" src="assets/img/visual-integration.png" />
    </div>
  </div>
</section>

<section class="container" anchor="ai">

  <app-section-intro>
    <span headline>Künstliche Intelligenz  <br class="d-none d-lg-inline" /> made in Germany</span>
    Made in Germany und spezifisch trainiert für mehr als 30k Unternehmen aus dem deutschsprachigen Raum: Unsere KI kennt dein Unternehmen schon jetzt.
  </app-section-intro>

  <div class="row align-items-center mt-6">
    <div class="col-12 col-lg-6">
      <img class="img-fluid" src="assets/img/visual-ai.png" />
    </div>
    <div class="col-12 col-lg-6">
      <h2>
        Trainiert für 30k Unternehmen  <br class="d-none d-lg-inline" /> aus dem deutschsprachigen Raum
      </h2>

      <p>
        Die skillconomy-KI geht über die Integration von ChatGPT und Co. weit hinaus: Unsere KI-Modelle wurden von uns entwickelt und speziell für den deutschsprachigen Raum auf über 20 Mio. Profilen trainiert. Dabei erlernen sie unternehmensspezifische Anforderungen für mehr als 30.000 Unternehmen. Screent die KI für eine deiner Stellen, fließt also automatisch detailliertes Wissen über deine spezifischen Anforderungen ein: rollenspezifische Skills, von euch genutzte Software, bevorzugte Ausbildungswege und vieles mehr.
      </p>

      <a class="fw-bold d-inline-block mt-2" href="https://docs.skillconomy.com/ki/unsere-ki" target="_blank">
        <i class="fa-sharp fa-solid fa-arrow-right me-2"></i>
        <u>Mehr erfahren</u>
      </a>
    </div>
  </div>
</section>

<section class="container">
  <div class="row justify-content-center">

    <div class="col-12 col-lg-8">
      <h1 class="text-center highlight">
        Mit <span class="emphasize">skillconomy</span> wird Active Sourcing einfacher als das Schalten einer Stellenanzeige.
      </h1>
    </div>
  </div>
</section>

<section class="container mt-4 benefits" anchor="benefits">
  <div class="row mt-n4">
    <div class="col-12 col-md-6 col-lg-4 mt-4">
      <app-card-benefit headline="Active Sourcing ohne Aufwand">
        <i icon class="fa-solid fa-bolt fa-2x text-muted"></i>
        Briefing, Screening, Ansprache – was beim manuellen Active Sourcing Stunden kostet, läuft mit skillconomy automatisiert.
      </app-card-benefit>
    </div>

    <div class="col-12 col-md-6 col-lg-4 mt-4">
      <app-card-benefit headline="Beste Candidate Experience">
        <i icon class="fa-solid fa-user-check fa-2x text-muted"></i>
        Vorqualifizierte Bewerber:innen mit echtem Interesse – durch intelligente, personalisierte Jobsites.
      </app-card-benefit>
    </div>

    <div class="col-12 col-md-6 col-lg-4 mt-4">
      <app-card-benefit headline="DSGVO und EU AI Act">
        <i icon class="fa-sharp fa-solid fa-shield-halved fa-2x text-muted"></i>
        Rechtliche Vorgaben? Übernehmen wir – damit du dich ganz auf dein Recruiting konzentrieren kannst.
      </app-card-benefit>
    </div>

    <div class="col-12 col-md-6 col-lg-4 mt-4">
      <app-card-benefit headline="Nahtlose Integration in dein ATS">
        <i icon class="fa-solid fa-plug fa-2x text-muted"></i>
        Active Sourcing ohne Mehraufwand – ganz ohne zusätzliche Tools, direkt in dein ATS integriert.
      </app-card-benefit>
    </div>

    <div class="col-12 col-md-6 col-lg-4 mt-4">
      <app-card-benefit headline="Maximale Flexibilität">
        <i icon class="fa-solid fa-arrows-left-right-to-line fa-2x text-muted"></i>
        Skalierbar nach Bedarf – Flexibilität für deine Bedarfe, saisonale Schwankungen und strategisches Wachstum.
      </app-card-benefit>
    </div>

    <div class="col-12 col-md-6 col-lg-4 mt-4">
      <app-card-benefit headline="Höchste Kosteneffizienz">
        <i icon class="fa-solid fa-piggy-bank fa-2x text-muted"></i>
        Kosteneinsparung mit Strategie – günstiger als ein eigenes Active-Sourcing-Team oder externe Dienstleister.
      </app-card-benefit>
    </div>
  </div>
</section>

<section class="container">

  <app-section-intro>
    <span headline>Deep Dives</span>
    Du willst wissen, was dahinter steckt? In unseren Deep Dives adressieren wir alle praxisrelevanten Themen von ATS-Integration bis Compliance. Mit der Erfahrung aus 10 Jahren technologiegetriebenem Active Sourcing.
  </app-section-intro>

  <div class="row mt-6">
    <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mt-4">
      <app-card-article tag="Deep Dive: KI" headline="Matching & Qualifizierung" link="https://docs.skillconomy.com/ki/unsere-ki">
        Was macht unser Matching so treffsicher und worauf basieren unsere KI-Modelle? Wir erklären, wie unsere KI individuelle Must-Haves erkennt, Karrierepfade analysiert und dadurch Kandidat:innen erreicht, die im manuellen Sourcing verloren gegangen wären.
      </app-card-article>
    </div>

    <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mt-4">
      <app-card-article tag="Deep Dive: CX" headline="Experience & Conversion" link="https://docs.skillconomy.com/plattform/intelligente-jobsites">
        Wie schaffen wir es, dass passive Talente nicht nur reagieren, sondern sich wirklich bewerben? Hier erfährst du, wie individuell zugeschnittene Jobsites, personalisierte Ansprache und optimierte Bewerbungspfade zu deutlich höheren Conversion-Rates führen.
      </app-card-article>
    </div>

    <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mt-4">
      <app-card-article tag="Deep Dive: Integration" headline="ATS-Integration" link="https://docs.skillconomy.com/plattform/ats-integration">
        Wie genau spielt skillconomy mit deinem bestehenden System zusammen? In diesem Deep Dive zeigen wir, wie Stellen automatisiert erkannt, Bewerbungen ohne Umweg ins ATS überführt und Prozesse nahtlos in deine Infrastruktur eingebettet werden – ohne Mehraufwand für dein Team.
      </app-card-article>
    </div>

  </div>

</section>

<section anchor="faq">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10 col-xl-9">
        <app-faq-list>

          <app-faq-item>
            <span question>Wie unterscheidet sich skillconomy von klassischen Active-Sourcing-Tools?</span>
            <div>
              Im Gegensatz zu klassischen Tools, die du manuell bedienen musst, arbeitet skillconomy vollständig automatisiert. Unsere Plattform erkennt offene Stellen direkt von deiner Karriereseite, findet in Sekunden passende Kandidat:innen aus über 20 Mio. Profilen und erstellt personalisierte Jobsites. Die Ansprache erfolgt über uns, Bewerbungen landen direkt in deinem ATS – ohne dass du selbst sourcen, schreiben oder vorqualifizieren musst.

            </div>
          </app-faq-item>

          <app-faq-item>
            <span question>Brauchen wir eigene Recruiter:innen oder Zugänge zu Business-Netzwerken?</span>
            <div>
              Nein. Die komplette Ansprache passiver Kandidat:innen läuft über unsere Infrastruktur – inklusive aller relevanten Business-Plattformen. Du brauchst weder interne Ressourcen noch eigene Lizenzen oder Zugangsdaten. Das bedeutet: keine Kosten, kein operativer Aufwand, keine zusätzlichen Tools.
            </div>
          </app-faq-item>

          <app-faq-item>
            <span question>Wie stellt skillconomy Datenschutz und regulatorische Konformität sicher?</span>
            <div>
              Unsere Lösung ist vollständig DSGVO-konform – inklusive aller Prozesse zur Datenerhebung, Speicherung und Ansprache. Das Hosting erfolgt ausschließlich in zertifizierten Rechenzentren innerhalb Europas. Zusätzlich wurde unsere KI-Architektur von Grund auf mit Blick auf die Anforderungen des EU AI Act entwickelt – für maximale Sicherheit und regulatorische Zukunftsfähigkeit.
            </div>
          </app-faq-item>

          <app-faq-item>
            <span question>Für welche Recruiting-Szenarien eignet sich skillconomy besonders?</span>
            <div>
              skillconomy ist als Standard-Lösung für mittelgroße und große Unternehmen konzipiert, die strukturiert und effizient den passiven Bewerbermarkt für Fach- und Führungspositionen erreichen wollen. Unsere Plattform passt sich schwankenden Bedarfssituationen an und führt zu einer massiven Entlastung deines Recruiting-Teams. Auch wenn du nur einzelne Positionen besetzen möchtest, können wir dich mit unserem einfachen und schlanken Ansatz unterstützen.
            </div>
          </app-faq-item>

          <app-faq-item>
            <span question>Wie läuft die Zusammenarbeit ab? Kann ich skillconomy testen?</span>
            <div>
              Unsere Partnerschaft orientiert sich an unserem Kunden-Framework, das darauf ausgerichtet ist, in transparenten Schritten deinen Mehrwert und deine Recruiting-Excellence zu steigern. Als ersten Schritt starten wir mit einer Pilotphase, die wir gemeinsam an deinen Bedürfnissen und Bedarfen ausrichten.
            </div>
          </app-faq-item>

        </app-faq-list>

      </div>
    </div>
  </div>
</section>

<section>
  <div class="container">
    <div class="row align-items-lg-center">
      <div class="col-12 col-md-12 col-lg-12">
        <app-cta></app-cta>
      </div>
    </div>
  </div>
</section>

<section class="container">

  <app-section-intro>
    <span headline>Events</span>
    Lerne uns persönlich kennen – auf Messen, Fachkongressen und Online-Formaten. Wir geben Einblicke in unsere Technologie, zeigen reale Anwendungsbeispiele und beantworten deine Fragen rund um KI-basiertes Active Sourcing.
  </app-section-intro>

  <div class="row mt-6">

    <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mt-4">
      <app-card-event tag="München, 04.-05.06.2025" headline="TALENTpro" image="assets/img/talentpro.jpg" link="https://www.talentpro.de">
        Active Sourcing, das so einfach funktioniert wie eine Stellenanzeige? Wie das geht, zeigen wir auf der TALENTpro an unserem Stand F.07. Hier erlebst du live, wie unsere KI-Sourcing-Plattform den passiven Bewerbermarkt zugänglich macht - skalierbar, einfach und mit einem Klick.
      </app-card-event>
    </div>

    <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mt-4">
      <app-card-event tag="Köln, 10.-12.09.2025" headline="Zukunft Personal Europa" image="assets/img/zpe.jpg" link="https://www.zukunft-personal.com">
        Wie einfach kann Active Sourcing sein? Erlebe unsere Technologie an unserem Stand. Unsere KI-Sourcing-Plattform bringt passende Talente aus dem passiven Bewerbermarkt direkt zu dir ins ATS - mit einem Klick und so einfach wie bei klassischen Stellenanzeigen.
      </app-card-event>
    </div>

    <div class="col-12 col-md-8 offset-md-2 col-xl-4 offset-xl-0 mt-4">
      <app-card-event tag="Berlin, 24.-25. September 2025" headline="KI-X HR Convention" image="assets/img/kix.png" link="https://hr.ki-x.berlin/">
        Der KI-X HR ist die Convention für den Einsatz von KI im Recruiting. Wir zeigen dir konkret, wie sich unsere Plattform mit deinem ATS verbindet - und welche Prozesse du schon heute vollständig automatisieren kannst.
      </app-card-event>
    </div>

  </div>

</section>
